// extracted by mini-css-extract-plugin
module.exports =  {"body":"DateView-module__body___fnAg4","date":"DateView-module__date___lOs4p"};